import { render, staticRenderFns } from "./MobileWarning.vue?vue&type=template&id=5092d95c&"
import script from "./MobileWarning.vue?vue&type=script&lang=js&"
export * from "./MobileWarning.vue?vue&type=script&lang=js&"
import style0 from "./MobileWarning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports